<template>
  <FormGroup :name="name" :label="label" :required="required" :inline="inline" :errors="errors">
    <div :class="{ 'input-group': inputGroup }">
      <slot name="prefix" />
      <input :id="name" :type="inputType" :placeholder="placeholder" :value="value | displayValue(this.type)"
        :disabled="disabled" class="form-control" :class="{ 'form-control-danger': errors }" @input="input"
        @keyup.enter="enter" @blur="blur" />
      <slot name="suffix" />
      <slot />
    </div>
  </FormGroup>
</template>

<script>
import FormGroup from "./FormGroup";
import helper from "@/libs/helper";

export default {
  name: "InputText",
  components: {
    FormGroup
  },
  filters: {
    displayValue(value) {
      return value;
    }
  },
  props: {
    type: String,
    name: String,
    value: [String, Number],
    label: String,
    placeholder: String,
    inputGroup: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errors: Array,
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputType() {
      return this.type === "number" ? "text" : this.type;
    }
  },
  methods: {
    input(event) {
      // console.log("Value0: " + event.target.value);
      // switch (this.type) {
      //   case 'money':
      //     this.value = helper.moneyDisplay(event.target.value);
      //     break;
      //   case 'number':
      //     this.value = helper.numberDisplay(event.target.value);
      //     break;
      // }
      // console.log("Value1: " + this.value);
      this.$emit("input", event.target.value);
    },
    enter(event) {
      this.$emit("enter", event.target.value);
    },
    blur(event) {
      this.$emit("blur", event.target.value);
    }
  }
};
</script>

<style scoped></style>
